module.exports = __webpack_public_path__ + "img/arrows-up-down-left-right.aa99b92f.svg";